module.exports = __webpack_public_path__ + "img/notice1.09a68713.png";